module.exports = __webpack_public_path__ + "static/media/inc_travel_covid.abc5da9e.svg";